<div class="app-hyperlink-button">
  <div class="app-hyperlink-button-enabled" type="submit" (click)="buttonClicked()">
    <img class="app-hyperlink-button-enabled-icon" [src]="buttonIconPath" />
    <div>{{ buttonTextPath | labelsProvider }}</div>
  </div>
</div>
